<script>
    import { curveStepBefore } from "d3";



export let key, x, yPosition, violinPlotData, violinFuncs, seriesParametersArray, circleData, label, labelYValue = 0, backgroundToLabel = true, labelFontSize = "14px", radius=8, hoverLabel = false;

function handleMouseOver(e) {

        d3.select(this.parentNode.parentNode.parentNode).selectAll(".plot-group").attr("opacity", 0.25)
        d3.select(this.parentNode.parentNode).selectAll("circle").attr("opacity", 0)
        
        d3.select(this).attr("opacity", 1).style("fill", "orange")
        d3.select(this.parentNode).select(".tooltipLabel").selectAll("text").attr("opacity", 1)
        d3.select(this.parentNode.parentNode).attr("opacity", 1)
        
}

function handleMouseOut(e) {
		
        d3.select(this.parentNode.parentNode.parentNode).selectAll(".plot-group").attr("opacity", 1)
        d3.select(this.parentNode.parentNode).selectAll("circle").attr("opacity", 1)
        
        d3.select(this).attr("opacity", 1).style("fill", null)
        d3.select(this.parentNode).select(".tooltipLabel").selectAll("text").attr("opacity", 0)
}


</script>

<g class="plot-group"
transform={"translate("+0+","+yPosition+")"}>

    {#if !key}

        <line
        y1=0
        y2=0
        x1=5
        x2={x(Math.min(...circleData))}
        stroke="#e0dede"
        fill="none"
        stroke-width="0.5px"
        opacity=1
        ></line>

    {/if}

    <g class="distribution-curve-group">

        {#each violinFuncs as violinFunc}

            <path
            d={violinFunc(violinPlotData)}
            stroke="none"
            fill="#e0dede"
            opacity=1
            ></path>
            
        {/each}
    
    </g>

    {#if label != "Young people in education, employment and apprenticeships"}

    {#if !key}

        {#if backgroundToLabel}

            <text class="subdomain-labels-border"
            y={4+labelYValue}
            x=0
            stroke="white"
            fill="white"
            font-size={labelFontSize}
            text-anchor="start"
            stroke-width="6px"
            >{label}</text>

        {/if}

        <text class="subdomain-labels-main"
        y={4+labelYValue}
        x=0
        stroke="none"
        fill="#333"
        font-size={labelFontSize}
        text-anchor="start"
        >{label}</text>

    {/if}

    {:else}


        {#if backgroundToLabel}

        <text class="subdomain-labels-border"
        y={3+labelYValue}
        x=0
        stroke="white"
        fill="white"
        font-size={"12px"}
        text-anchor="start"
        stroke-width="6px"
        >Young people in education,</text>

        <text class="subdomain-labels-border"
        y={16+labelYValue}
        x=0
        stroke="white"
        fill="white"
        font-size={"12px"}
        text-anchor="start"
        stroke-width="6px"
        >employment and apprenticeships</text>

        {/if}

        <text class="subdomain-labels-main"
        y={3+labelYValue}
        x=0
        stroke="none"
        fill="#333"
        font-size={"12px"}
        text-anchor="start"
        >Young people in education,</text>

        <text class="subdomain-labels-main"
        y={16+labelYValue}
        x=0
        stroke="none"
        fill="#333"
        font-size={"12px"}
        text-anchor="start"
        >employment and apprenticeships</text>



    {/if}

    {#each seriesParametersArray as series, j}

        <g>

        <circle on:mouseover={hoverLabel ? handleMouseOver: null} on:focus={null} on:mouseleave={hoverLabel ? handleMouseOut: null}
        cx={x(circleData[j])}
        cy={circleData.length == 2 ? (Math.abs(x(circleData[0])-x(circleData[1]))>10 ? 0 : [4,-4][j]) : 0}
        r={radius}
        stroke="white"
        fill={series["color"]}
        stroke-width="1.5px"
        ></circle>

        {#if hoverLabel}

            <g class=tooltipLabel>

                <text
                x={x(circleData[j])}
                y={circleData.length == 2 ? (Math.abs(x(circleData[0])-x(circleData[1]))>10 ? -radius*1.5 : -radius*1.5+[4,-4][j]) : -radius*1.5}
                font-size={"14px"}
                pointer-events="none"
                stroke-width="3px"
                opacity=0
                stroke={"white"}
                fill={"white"}
                text-anchor="middle"
                >{circleData[j].toFixed(1)}</text>

                <text
                x={x(circleData[j])}
                y={circleData.length == 2 ? (Math.abs(x(circleData[0])-x(circleData[1]))>10 ? -radius*1.5 : -radius*1.5+[4,-4][j]) : -radius*1.5}
                font-size={"14px"}
                pointer-events="none"
                stroke-width="1px"
                opacity=0
                stroke={series["color"]}
                fill={series["color"]}
                text-anchor="middle"
                >{circleData[j].toFixed(1)}</text>

            </g>
        
        {/if}

        </g>
    {/each}

</g>